const footerRoutes = [
    {
        title: 'Terms & Conditions',
        url: 'https://bumble.com/en/terms',
    },
    {
        title: 'Privacy Policy',
        url: 'https://bumble.com/en/privacy',
    },
    {
        title: 'Cookies Policy',
        url: 'https://bumble.com/cookie-policy',
    },
];

export default footerRoutes;
